import React, { useContext, createContext } from "react";

const AppContext = createContext();

export { AppContext };
